import { useDispatch, useSelector } from 'react-redux';
import { BasilCrossOutline } from '../../../assets/icons/Icons'
import { PRODUCT_SIZE } from '../../../constant/constant';
import { selectAvailableCategories, selectAvailableSize, selectCategories, selectSize, setSelectSingleCategory, setSelectSingleSize,  } from '../../../features/guest/guestSlice';
import useGuestAction from '../../../hooks/actions/useGuestAction';
import { useState } from 'react';
import { ArrowDown, ArrowUp, DropDownArrowIcon } from '../../../assets/icons/Svg';


export default function Category() {

    const dispatch = useDispatch()
    const selectedCategories = useSelector(selectCategories)
    const availableSize = useSelector(selectAvailableSize)
    const selectedSize = useSelector(selectSize)
    const availableCategories = useSelector(selectAvailableCategories)
    
    const { handleSelect, handleRemove, handleSelectSize, handleRemoveSize, } = useGuestAction()
    
    const sortedCategories = [
        ...availableCategories.filter((cat) => selectedCategories.includes(cat)),
        ...availableCategories.filter((cat) => !selectedCategories.includes(cat)),
    ];

    const filteredSizes = availableSize.filter(size => size.toLowerCase() !== PRODUCT_SIZE.sNone.name.toLowerCase());
    const sortedSizes = [
        ...filteredSizes.filter((size) => selectedSize.includes(size)),
        ...filteredSizes.filter((size) => !selectedSize.includes(size)),
    ];
    
    const [showCategories, setShowCategories] = useState<boolean>(false)
    const [showSize, setShowSize] = useState<boolean>(false)

    return (
        <div className='w-full rounded grid grid-cols-2 gap-2'>
            <div className='rounded space-y-1 bg-cbColorSecond py-2 px-2.5'>
                <p className='text-cbColorDark text-xs font-medium'>Available Category:</p>
                {/* <div className='flex flex-wrap gap-2'>
                    {sortedCategories.map((cat, i) => {
                        const isSelected = selectedCategories.includes(cat);
                        return (
                            <div 
                                key={i} 
                                className={`flex items-center text-xs font-medium px-2.5 py-1 rounded-full cursor-pointer transition bg-white text-cbColorDark`}
                                onClick={() => (isSelected ? handleRemove(cat) : handleSelect(cat))}
                            >
                                <span>{cat}</span>
                                {isSelected && (
                                    <div
                                        className="ml-2 flex items-center justify-center rounded-full bg-cbColorSecond text-xs font-bold hover:bg-gray-200 transition"
                                    >
                                        <BasilCrossOutline width={16} height={16} />
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </div> */}
                <div className='relative'>
                    <button 
                        className='w-full flex justify-between items-center rounded border border-gray-300 bg-white px-2 py-1 text-xs outline-none focus:border-cbColorPrimary'
                        onClick={() => {
                            setShowCategories(!showCategories)
                            setShowSize(false)
                        }}
                    >
                        <div className="text-[12px] md:text-[13px]">{selectedCategories}</div>
                        <div className="w-3 h-3 flex-shrink-0">{showCategories ? <ArrowUp /> : <ArrowDown />}</div>
                    </button>
                    {showCategories && (
                        <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-300" >
                            {availableCategories.map((opt, i) => (
                                <li
                                    key={i}
                                    onClick={() => {
                                        setShowCategories(!showCategories)
                                        dispatch(setSelectSingleCategory(opt))
                                    }}
                                    className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-xs'
                                >
                                    {opt}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                
            </div>
            <div className='rounded bg-cbColorSecond py-2 px-2.5'>
                <div className='space-y-1'>
                    <p className='text-cbColorDark text-xs font-medium'>Available Size:</p>
                    {/* <div className='flex flex-wrap gap-2'>
                        {sortedSizes.map((size, i) => {
                            const isSelectedSize = selectedSize.includes(size);
                            return (
                            <div 
                                key={i} 
                                className={`flex items-center text-xs font-medium px-2.5 py-1 rounded-full cursor-pointer transition bg-white text-cbColorDark`}
                                onClick={() => (isSelectedSize ? handleRemoveSize(size) : handleSelectSize(size))}
                            >
                                <span>{size}</span>
                                {isSelectedSize && (
                                    <div
                                        className="ml-2 flex items-center justify-center rounded-full bg-cbColorSecond text-xs font-bold hover:bg-gray-200 transition"
                                    >
                                        <BasilCrossOutline width={16} height={16} />
                                    </div>
                                )}
                            </div>
                        )})}
                    </div> */}
                    <div className='relative'>
                        <button 
                            className='w-full flex justify-between items-center rounded border border-gray-300 bg-white px-2 py-1 text-xs outline-none focus:border-cbColorPrimary'
                            onClick={() => {
                                setShowSize(!showSize)
                                setShowCategories(false)
                            }}
                        >
                            <div className="text-[12px] md:text-[13px]">{selectedSize}</div>
                            <div className="w-3 h-3 flex-shrink-0">{showSize ? <ArrowUp /> : <ArrowDown />}</div>
                        </button>
                        {showSize && (
                            <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-300" >
                                {availableSize.map((opt, i) => (
                                    <li
                                        key={i}
                                        onClick={() => {
                                            setShowSize(!showSize)
                                            dispatch(setSelectSingleSize(opt))
                                        }}
                                        className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-xs'
                                    >
                                        {opt}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
